export const API_URL =
  process.env.NODE_ENV === "development" ? "/" : "https://api.rendimasinad.ee/";

export const API_HEADERS = {
  "Content-Type": "application/json",
  "X-API-Key": process.env.GATSBY_API_KEY || "",
};
